import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from '../contexts/authentication'; // Import your auth context

export default function ProtectedRoute({ element }) {
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
        navigate('/'); // Redirect to login if not authenticated
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null; // Optionally, you can show a loading spinner here
  }

  return element; // If authenticated, render the protected route
};
